export const ptiaVersementEnum = Object.freeze({
  CAPITAL: 'CAPITAL',
  RENTE: 'RENTE'
});
